import { Link, useSearch } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { DirectoryView } from "./directory/DirectoryView";

/**
 * Financial-aids directory area (route: /financial-aids). Like the tool
 * directory, aids are reached contextually from a piste d'action (the Aides
 * financières icon on an action-plan action links here with ``?action=<id>``).
 * Without an action there is nothing to browse, so we point back to the plan.
 */
export function FinancialAidsArea() {
  const { t } = useTranslation();
  const search = useSearch({ strict: false }) as {
    action?: unknown;
    fav?: unknown;
  };
  const action = typeof search.action === "string" ? search.action : null;
  const favoritesDefault = search.fav === true;

  if (!action) {
    return (
      <div className="mx-auto max-w-2xl">
        <Card>
          <CardHeader>
            <CardTitle>
              {t("financialAids.directory.actionRequired.title")}
            </CardTitle>
            <CardDescription>
              {t("financialAids.directory.actionRequired.help")}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button asChild>
              <Link to="/action-plans">
                {t("financialAids.directory.actionRequired.goToPlans")}
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="text-3xl font-bold">{t("financialAids.title")}</h1>
        <p className="text-muted-foreground">{t("financialAids.subtitle")}</p>
      </header>
      <DirectoryView action={action} favoritesDefault={favoritesDefault} />
    </div>
  );
}
